export default {
  'register.steps.general.title': 'Company',
  'register.steps.general.description': 'Your company information',
  'register.steps.contact.title': 'Contact',
  'register.steps.contact.description': 'Contact information',
  'register.steps.account.title': 'Access',
  'register.steps.account.description': 'User Information',
  'register.steps.confirm.title': 'Confirmation',
  'register.steps.confirm.description': 'Confirm registration',
  'register.form.button.next': 'Next',
  'register.form.button.previous': 'Previous',
  'register.form.button.register': 'Register',
  'register.form.general.name.label': 'Company Name',
  'register.form.general.name.message': 'Inform the company name',
  'register.form.general.companyType.label': 'Type',
  'register.form.general.companyType.message': 'Choose the type of company',
  'register.form.general.cnpj.label': 'CNPJ',
  'register.form.general.cnpj.message': 'Inform the CNPJ',
  'register.form.general.contactName.label': 'Contact name',
  'register.form.general.contactName.message': 'Inform contact name',
  'register.form.general.phone.label': 'Phone',
  'register.form.general.phone.message': 'Enter a contact phone number',
  'register.form.general.email.label': 'E-mail',
  'register.form.general.email.message': 'Enter an email to contact',
  'register.form.general.email.message.valid':
    'Please enter a valid email address',
  'register.form.contact.zip.label': 'Zip code',
  'register.form.contact.zip.message': 'Enter the zip code',
  'register.form.contact.zip.message.valid': 'Enter a valid zip code',
  'register.form.contact.id.label': 'UF',
  'register.form.contact.id.message': 'Choose a UF',
  'register.form.contact.idCity.label': 'City',
  'register.form.contact.idCity.message': 'Choose a city',
  'register.form.contact.district.label': 'District',
  'register.form.contact.district.message': 'Inform a district',
  'register.form.contact.street.label': 'District',
  'register.form.contact.street.message': 'Inform a district',
  'register.form.contact.number.label': 'Number',
  'register.form.contact.number.message': 'Inform a number',
  'register.form.contact.complement.label': 'Complement',
  'register.form.account.login.label': 'Username',
  'register.form.account.login.message': 'Inform a username',
  'register.form.account.password.label': 'Password',
  'register.form.account.password.message': 'Inform a password',
  'register.form.account.password.message.valid':
    'The password must be at least 8 characters long, and have at least one uppercase letter and a number',
  'register.form.account.passwordVerify.label': 'Confirm password',
  'register.form.account.passwordVerify.message': 'Re-enter password',
  'register.form.account.passwordVerify.message.valid':
    'Both passwords must be the same',
  'register.form.confirm.checkbox.label': 'I confirm the data entered',
  'register.form.confirm.checkbox.message': 'Please check the option above',
  'register.form.confirm.success.title': 'Account created successfully!',
  'register.form.confirm.success.subTitle':
    'Your Ultracar Web account has been successfully created! An activation link was sent to the registered email.',
  'register.form.confirm.success.button': 'Go to login',
  'register.form.notification.success': 'Account created successfully!',
  'register.form.notification.successDescription':
    'Your account has been successfully created.',
  'register.form.notification.error': 'Error creating account',
  'register.form.notification.errorDescription':
    'An error occurred while trying to create the account. Please check the fields and try again.',
  'register.form.notification.error.duplicateEmail': 'Duplicate E-mail',
  'register.form.notification.error.duplicateEmail.description':
    'The e-mail "{email}" already exists.',
  'register.form.notification.error.duplicateUser': 'Duplicate User',
  'register.form.notification.error.duplicateUser.description':
    'User "{loginDuplicate}" is already in use.',
};
